import React, { ChangeEvent, useEffect, useState } from 'react';

import aguid from 'lib/aguid';

import GaugeForm from './GaugeForm';

const GaugeFormContainer = ({
  gauge,
  onChange,
}: {
  gauge?: VisualisationDefinitions.Gauge;
  onChange?: React.Dispatch<
    React.SetStateAction<undefined | VisualisationDefinition>
  >;
}) => {
  // Base
  const [id] = useState(gauge ? gauge.id : aguid());
  const [name, setName] = useState<string>(gauge ? gauge.name : '');
  const [description, setDescription] = useState<string>(
    gauge ? gauge.description : '',
  );
  // Gauge specific
  const [metricId, setMetricId] = useState<string | undefined>(
    gauge ? gauge.metricId : undefined,
  );
  const [metricDisplayName, setMetricDisplayName] = useState<string>(
    gauge ? gauge.metricDisplayName : '',
  );
  const [peerGroup, setPeerGroup] = useState<string | undefined>(
    gauge ? gauge.peerGroup : '',
  );
  const [entity, setEntity] = useState<string | undefined>(
    gauge ? gauge.entity : '',
  );
  const [isLoading] = useState<boolean>(false);
  const [draftGauge, setDraftGauge] = useState<
    VisualisationDefinitions.Gauge | undefined
  >();
  const [isReversed, setIsReversed] = useState<boolean>(
    gauge?.isReversed || false,
  );

  const onNameChanged = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const onMetricDisplayNameChanged = (event: ChangeEvent<HTMLInputElement>) => {
    setMetricDisplayName(event.target.value);
  };

  const onDescriptionChanged = (event: ChangeEvent<HTMLInputElement>) => {
    setDescription(event.target.value);
  };

  const isValid = name !== '' && metricId !== '' && !!entity && !!peerGroup;

  useEffect(() => {
    const newDraftGauge = ((): VisualisationDefinitions.Gauge | undefined => {
      if (
        name !== '' &&
        metricId !== '' &&
        !!metricId &&
        !!entity &&
        !!peerGroup
      ) {
        return {
          id,
          type: 'Gauge',
          name,
          description,
          metricId,
          metricDisplayName,
          peerGroup,
          entity,
          isReversed,
        };
      }

      return undefined;
    })();

    setDraftGauge(newDraftGauge);
  }, [
    description,
    entity,
    id,
    isReversed,
    metricDisplayName,
    metricId,
    name,
    peerGroup,
  ]);

  useEffect(() => {
    if (draftGauge && onChange) {
      onChange(draftGauge);
    }
  }, [draftGauge, onChange]);

  return (
    <GaugeForm
      name={name}
      onNameChanged={onNameChanged}
      description={description}
      onDescriptionChanged={onDescriptionChanged}
      metricId={metricId}
      setMetricId={setMetricId}
      metricDisplayName={metricDisplayName}
      onMetricDisplayNameChanged={onMetricDisplayNameChanged}
      setMetricDisplayName={setMetricDisplayName}
      peerGroup={peerGroup}
      setPeerGroup={setPeerGroup}
      entity={entity}
      setEntity={setEntity}
      isValid={isValid}
      isLoading={isLoading}
      draftGauge={draftGauge}
      isReversed={isReversed}
      setIsReversed={setIsReversed}
    />
  );
};

export default GaugeFormContainer;
